<script setup lang="ts">
	interface Props {
		title?: string
		description?: string
		iconType?: string
		iconDir?: string
		showCta?: boolean
		ctaText?: string
	}

	withDefaults(defineProps<Props>(), {
		title: 'Access Restricted',
		description:
			"You don't have the required permissions to view this section. Please contact your administrator if you believe this is an error.",
		iconType: 'user-forbid',
		iconDir: 'fill',
		showCta: false,
		ctaText: 'Request Access'
	})

	defineEmits<{
		(e: 'cta-click'): void
	}>()
</script>

<template>
	<div
		class="no-permission-placeholder light-shadow flex flex-col items-center justify-center rounded-xl border border-dashed border-gray-200 bg-white p-8 text-center"
	>
		<div class="icon-wrapper mb-6 rounded-full border border-gray-100 bg-white p-4 shadow-sm">
			<slot name="icon">
				<lazy-tools-icon :icon="iconType" :dir="iconDir" :height="48" :width="48" />
			</slot>
		</div>

		<h3 class="mb-2 text-xl font-semibold italic text-gray-800">
			{{ title }}
		</h3>

		<p class="mx-auto mb-8 max-w-md font-medium leading-relaxed text-gray-500">
			{{ description }}
		</p>

		<slot name="cta">
			<a-button
				v-if="showCta"
				type="primary"
				class="default-btn h-11 border-primary-2 bg-primary-2 px-8"
				@click="$emit('cta-click')"
			>
				{{ ctaText }}
			</a-button>
		</slot>

		<slot />
	</div>
</template>

<style scoped>
	.no-permission-placeholder {
		min-height: 300px;
		transition: all 0.3s ease;
	}

	.no-permission-placeholder:hover {
		border-color: theme('colors.primary.2');
	}

	.icon-wrapper {
		animation: lock-bounce 2s infinite ease-in-out;
	}

	@keyframes lock-bounce {
		0%,
		100% {
			transform: translateY(0);
		}
		50% {
			transform: translateY(-5px);
		}
	}
</style>
